import Vue from 'vue'
import DataService from '../../services/data'

export const SET_COUNTRIES = 'SET_COUNTRIES'

const state = {
  countries: []
}

const getters = {
  alpha2ToName(state) {
    return state.countries.reduce((acc, val) => {
      acc[val.alpha2] = val.name
      return acc
    }, {})
  }
}

const actions = {
  fetchIsrsConfig({commit, rootState}) {
    const profile = Vue.prototype.profile
    const dataService = new DataService(profile, rootState.tokens)
    
    return dataService.getIsrsConfig()
      .then( result => result.data)
      .then( data => {
        commit(SET_COUNTRIES, data.countries)
      })
  }
}

const mutations = {
  SET_COUNTRIES(state, countries) {
    state.countries = countries
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/config.js